import { BasePanelController } from '../../../../../BaseUI/BasePanelController';
import { HealthInsureSettingPanelComponent } from './HealthInsureSettingPanelComponent';

import { HealthInsureService } from 'src/app/Service/HealthInsureService';
import {HealthInsureDTOInterface} from '../../../../../../DTO/HealthInsureDTOInterface';


/**
 * HealthInsureSettingPanelController
 * 保険証アップロード画面のコントローラー
 */
export class HealthInsureSettingPanelController extends BasePanelController {
	public combineView: HealthInsureSettingPanelComponent;


	/**
	 * getHealthInsureData
	 * 保険証データを取得する
	 * @param param view: 元画面
	 * @returns 保険証の簡易データリスト
	 */
	public async getHealthInsureData(param: { view: any }) {

		// Serviceからデータを取得する
		const svc = new HealthInsureService(param.view);
		const ret = await svc.getHealthInsure();

		return ret;


	}

	/**
	 * sendHealthInsureData
	 * 保険証データを送信する
	 * @param param view: 元画面 fileData: 送信するファイルデータ
	 * @returns 成功時の保存状態のデータ
	 */
	public async sendHealthInsureData(param: { view: any; fileData: any }) {

		// Serviceからデータを保存する
		const svc = new HealthInsureService(param.view);
		const ret = await svc.uploadHealthInsure(param.fileData);

		return ret;

	}

	/**
	 * changeHealthInsureData
	 * 保険証の変更
	 * @param param view: 元画面 fileInfoId: ファイルID displayName: 表示名 uploadFile: 変更するファイル
	 * @returns 変更後の保存状態データ
	 */
	public async changeHealthInsureData(param: { view: any; fileInfoId: number; displayName: string; uploadFile: any}) {

		const svc = new HealthInsureService(param.view);
		const ret = await svc.changeHealthInsure(param.fileInfoId, param.displayName, param.uploadFile);

		return ret;

	}

	/**
	 * 保険証の削除
	 * 表・裏両方削除する
	 * @param param
	 */
	public async deleteHealthInsureData(param: { view: any; healthInsureData: HealthInsureDTOInterface }) {

		const svc = new HealthInsureService(param.view);
		const res = await Promise.all([
			svc.deleteHealthInsure(param.healthInsureData.front.id),
			svc.deleteHealthInsure(param.healthInsureData.back.id)
		]);

		return res;

	}

}
